export const downloadFile = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");

  a.href = url;
  a.download = filename;
  a.click();
  a.remove();
};

export const getMimeHeaders = (type) => ({
  Accept:
    type == 2
      ? "application/pdf"
      : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
});

export const getBase64File = (blob) => {
  return new Promise((resolve, reject) => {
    let nombre = "Archivo";
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.fileName = nombre[1] || nombre[0];
    reader.onloadend = function (name) {
      name = nombre[0];
      var base64data = reader.result;
      resolve(base64data);
    };
  });
};
